/* eslint-disable import/no-extraneous-dependencies */
import Qs from 'qs'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getSalesPeople = async (
  cancel: any,
  query: string,
  classificacao: string[],
  page: number
): Promise<GetProductsType | { message: string }> => {
  try {
    const result = await apiService.get('app/vendedor', {
      cancelToken: cancel.token,
      params: {
        query,
        classificacao,
        page: page - 1,
        size: 7,
      },
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getSalesPeopleResume = async (
  id: string
): Promise<GetProductResumeType | { message: string }> => {
  try {
    const result = await apiService.get(`app/vendedor/${id}/resumo`, {
      params: {
        id,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getSalesPeopleDetails = async (
  id: string,
  classificacao: Classification
): Promise<GetDetailsType[] | { message: string }> => {
  try {
    const result = await apiService.get(`app/vendedor/${id}/clientes`, {
      params: {
        classificacao,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getVendedoresAll = async (
  query: string
): Promise<GetCompanieAll | { message: string }> => {
  try {
    const result = await apiService.get('app/vendedor/all', {
      params: {
        query,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
